import { For, Match, Switch, createSignal } from "solid-js";
import { Participants, Teams } from "./components";

const tabs = ["participants", "teams"] as const;
export default function ParticipantsAndTeams() {
  const [$active_tab, setActiveTab] = createSignal("participants" as (typeof tabs)[number]);

  function onTabClicked(tab: (typeof tabs)[number]) {
    setActiveTab(tab);
  }

  return (
    <section class="flex flex-col w-full h-full px-5 py-3 gap-2 !overflow-hidden <sm:(px-2 py-1 gap-y-2)">
      <h1 class="text-xl font-[600] text-black z-1 <sm:(text-22px)">Participants & Teams</h1>
      <div class={"flex justify-start items-center gap-4 h-55px" + " " + ""}>
        <For each={tabs}>
          {(tab) => {
            return (
              <p
                //
                class={
                  "text-20px font-bold capitalize cursor-pointer <sm:(!text-16px)" +
                  " " +
                  ($active_tab() === tab ? "text-brand border-b-5 border-solid border-brand" : "text-text-alt")
                }
                onclick={() => {
                  onTabClicked(tab);
                }}
              >
                {tab}
              </p>
            );
          }}
        </For>
      </div>
      <Switch>
        <Match when={$active_tab() === "participants"}>
          <Participants />
        </Match>
        <Match when={$active_tab() === "teams"}>
          <Teams />
        </Match>
      </Switch>
    </section>
  );
}
